import { API_BASE_URL } from '../config.js';
import { isSessionLoss } from '@globegroupe-data/auth-kit/browser';

// Set once by App: what to do when the BFF says the session is gone. onError is a
// per-call callback and most callers pass none, so without this a 401 raised mid
// session went nowhere and the app kept rendering as if signed in.
let onSessionExpired = () => {};
export const setSessionExpiredHandler = (fn) => {
  onSessionExpired = fn;
};

const fetchWithAuth = async (
  url,
  options = {},
  onError = () => {},
  onSuccess = () => {}
) => {
  const { returnRawResponse, ...fetchOptions } = options || {};

  // If url is relative, add the base url
  if (!url.startsWith('http')) {
    const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
    url = `${baseUrl}/${url.startsWith('/') ? url.substring(1) : url}`;
  }

  const contentType = options.headers?.['Content-Type'] || 'application/json';

  const headers = {
    'Content-Type': contentType,
    ...fetchOptions.headers,
  };

  const response = await fetch(url, {
    ...fetchOptions,
    credentials: fetchOptions.credentials || 'include',
    headers,
  });

  if (!response.ok) {
    // isSessionLoss et pas le statut : seuls les 401 portant le challenge
    // `WWW-Authenticate: Session` viennent de la couche session. Un 401 applicatif
    // (droit manquant, API tierce) ne doit pas déconnecter l'utilisateur.
    if (isSessionLoss(response)) onSessionExpired();
    onError(response);

    if (returnRawResponse) return response;
    throw new Error(`HTTP error! status: ${response.status}`, response);
  }

  if (returnRawResponse) {
    onSuccess(response, response);
    return response;
  }

  let data = response;

  if (contentType === 'application/json') {
    try {
      data = await response.json();
    } catch (error) {
      onError(error);
      throw error;
    }
  }

  onSuccess(data, response);

  return data;
};

// Base path for the GPS DWH form endpoints, scoped to a project key.
export const gpsApiBase = (projectKey) => `api/dwh/gps/${encodeURIComponent(projectKey)}`;

export default fetchWithAuth;